"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CREDIT_COUNSELING = exports.ILLEGAL_DEBT_COLLECTION = exports.BANKRUPTCY = void 0;
exports.BANKRUPTCY = "bankruptcy";
exports.ILLEGAL_DEBT_COLLECTION = "illegalDebtCollection";
exports.CREDIT_COUNSELING = "creditCounseling";